/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".equipment-icon[_ngcontent-%COMP%]{height:20px;width:20px;-webkit-filter:invert(1) brightness(10);filter:invert(1) brightness(10)}"];
export { styles as styles };
